// Ausserbetriebsetzung

// state
const state = {
    numTanks: null, //int
    tankSize: null, //int
    remainingOil: null, //int
    tankContent: '',
    tankLocation: '',
    tankMaterial: '',
    oilFromMigrol: null, //boolean
    oilFromMigrolInfo: '',
    includeRemoval: null //boolean
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    // address fields
    setNumTanks(state, newValue) {
        state.numTanks = newValue;
    },
    setTankSize(state, newValue) {
        state.tankSize = newValue;
    },
    setRemainingOil(state, newValue) {
        state.remainingOil = newValue;
    },
    setTankContent(state, newValue) {
        state.tankContent = newValue;
    },
    setTankLocation(state, newValue) {
        state.tankLocation = newValue;
    },
    setTankMaterial(state, newValue) {
        state.tankMaterial = newValue;
    },
    setOilFromMigrol(state, newValue) {
        state.oilFromMigrol = newValue;
    },
    setOilFromMigrolInfo(state, newValue) {
        state.oilFromMigrolInfo = newValue;
    },
    setIncludeRemoval(state, newValue) {
        state.includeRemoval = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}